const chipEmphasisVariants = {
    regular: {
        containerSlot: 'active:bg-primary-4 active:shadow-sm active:aria-pressed:shadow-sm aria-pressed:bg-primary-3 aria-pressed:border-transparent border-primary-6 hover:aria-pressed:bg-primary-4 hover:aria-pressed:not-active:shadow-lg hover:bg-primary-3',
        labelTextSlot: 'text-primary-13',
        iconLeftSlot: 'text-primary-13',
        iconRightSlot: 'text-primary-13',
        countSlot: 'text-primary-10'
    },
    medium: {
        containerSlot: 'active:bg-primary-4 active:shadow-sm active:aria-pressed:shadow-sm aria-pressed:bg-primary-4 aria-pressed:border-transparent border-primary-6 hover:aria-pressed:bg-primary-4 hover:aria-pressed:shadow-lg hover:bg-primary-4',
        labelTextSlot: 'text-primary-13',
        iconLeftSlot: 'text-primary-13',
        iconRightSlot: 'text-primary-13',
        countSlot: 'text-primary-10'
    },
    bold: {
        containerSlot: 'active:bg-primary-1/20 active:shadow-sm active:aria-pressed:shadow-sm aria-pressed:bg-primary-1/10 aria-pressed:border-transparent bg-primary-1/20 border-primary-1/40 hover:aria-pressed:bg-primary-1/20 hover:aria-pressed:shadow-lg hover:bg-primary-1/10 hover:border-primary-1/10',
        labelTextSlot: 'text-primary-1',
        helperTextSlot: 'text-primary-1',
        iconLeftSlot: 'text-primary-1',
        iconRightSlot: 'text-primary-1',
        countSlot: 'text-primary-6'
    }
};
const chipEmphases = Object.keys(chipEmphasisVariants);
const chipDisabledVariants = {
    true: {
        containerSlot: 'cursor-not-allowed hover:cursor-not-allowed focus-visible:outline-none shadow-none hover:shadow-none hover:aria-pressed:shadow-none'
    }
};
const chipElevatedVariants = {
    true: {
        containerSlot: 'hover:shadow-lg shadow-md'
    }
};
const chipCompoundVariants = [
    {
        disabled: true,
        elevated: true,
        class: {
            containerSlot: 'bg-transparent hover:shadow-none hover:bg-transparent active:bg-transparent shadow-none'
        }
    },
    {
        disabled: false,
        elevated: true,
        class: {
            containerSlot: 'border-transparent'
        }
    },
    {
        disabled: true,
        elevated: false,
        class: {
            containerSlot: 'bg-primary-2 hover:shadow-none shadow-none hover:aria-pressed:shadow-none'
        }
    },
    {
        disabled: true,
        elevated: true,
        class: {
            containerSlot: 'bg-primary-2 hover:shadow-none shadow-none hover:aria-pressed:shadow-none'
        }
    },
    {
        disabled: true,
        emphasis: 'regular',
        elevated: true,
        class: {
            containerSlot: 'active:bg-primary-2 aria-pressed:bg-primary-2 bg-primary-2 border-primary-5 hover:aria-pressed:bg-primary-2 hover:bg-primary-2 shadow-none',
            labelTextSlot: 'text-primary-6',
            iconLeftSlot: 'text-primary-6',
            iconRightSlot: 'text-primary-6',
            countSlot: 'text-primary-6'
        }
    },
    {
        emphasis: 'regular',
        elevated: false,
        class: {
            containerSlot: 'bg-transparent'
        }
    },
    {
        emphasis: 'regular',
        elevated: true,
        class: {
            containerSlot: 'bg-primary-1'
        }
    },
    {
        disabled: true,
        emphasis: 'regular',
        elevated: false,
        class: {
            containerSlot: 'active:bg-primary-1 aria-pressed:bg-primary-2 aria-pressed:border-primary-2 bg-primary-1 border-primary-5 hover:aria-pressed:bg-primary-2 hover:bg-primary-1 hover:border-primary-5 shadow-none',
            labelTextSlot: 'text-primary-6',
            iconLeftSlot: 'text-primary-6',
            iconRightSlot: 'text-primary-6',
            countSlot: 'text-primary-6'
        }
    },
    {
        disabled: true,
        emphasis: 'medium',
        class: {
            containerSlot: 'active:bg-transparent aria-pressed:bg-primary-1/60 aria-pressed:border-primary-1 bg-transparent border-primary-5 hover:aria-pressed:bg-primary-1/60 hover:bg-transparent hover:border-primary-5 shadow-none',
            labelTextSlot: 'text-primary-6',
            iconLeftSlot: 'text-primary-6',
            iconRightSlot: 'text-primary-6',
            countSlot: 'text-primary-6'
        }
    },
    {
        emphasis: 'medium',
        elevated: false,
        class: {
            containerSlot: 'bg-transparent'
        }
    },
    {
        emphasis: 'medium',
        elevated: true,
        class: {
            containerSlot: 'bg-primary-1'
        }
    },
    {
        disabled: true,
        emphasis: 'bold',
        class: {
            containerSlot: 'active:bg-transparent aria-pressed:bg-primary-2/20 bg-transparent border-primary-5/20 hover:aria-pressed:bg-primary-2/20 hover:bg-transparent hover:border-primary-5/20 shadow-none',
            labelTextSlot: 'text-primary-1/40',
            iconLeftSlot: 'text-primary-1/40',
            iconRightSlot: 'text-primary-1/40',
            countSlot: 'text-primary-1/40'
        }
    },
    {
        elevated: true,
        emphasis: 'bold',
        class: {
            containerSlot: 'border-primary-1/0'
        }
    },
    {
        elevated: false,
        emphasis: 'bold',
        class: {
            containerSlot: 'bg-transparent'
        }
    },
    {
        type: 'tile',
        class: {
            containerSlot: 'rounded-xl py-1 min-w-[180px]',
            iconLeftSlot: 'mr-1'
        }
    },
    {
        type: 'tile',
        hasHelperText: true,
        class: {
            labelTextSlot: 'pb-0'
        }
    },
    {
        type: 'tile',
        disabled: true,
        class: {
            helperTextSlot: 'text-primary-6'
        }
    },
    {
        type: 'tile',
        disabled: true,
        emphasis: 'bold',
        class: {
            helperTextSlot: 'text-primary-1/40'
        }
    },
    {
        showCheckIcon: false,
        class: {
            labelTextSlot: 'text-center'
        }
    },
    {
        showCheckIcon: false,
        hasIconLeft: true,
        class: {
            iconLeftSlot: 'opacity-100 scale-100',
            labelTextSlot: 'text-left'
        }
    }
];
export { chipCompoundVariants, chipDisabledVariants, chipElevatedVariants, chipEmphases, chipEmphasisVariants };
